module.exports = __webpack_public_path__ + "static/media/waitingroom.6ea5130f.svg";